// export const countryPinCodeData = [
//   {
//     name: "India",
//     dial_code: "+91",
//     code: "IN",
//     pinCodeLength: 6,
//     phoneNumberLength: 10,
//   },
//   {
//     name: "Singapore",
//     dial_code: "+65",
//     code: "SG",
//     pinCodeLength: 6,
//     phoneNumberLength: 8,
//   },
// ];'

export const countryPinCodeData = [
  {
    "name": "Andorra",
    "dial_code": "+376",
    "phoneNumberLength": [6],
    "code": "AD"
  },
  {
    "name": "United Arab Emirates",
    "dial_code": "+971",
    "phoneNumberLength": [9],
    "code": "AE"
  },
  {
    "name": "Afghanistan",
    "dial_code": "+93",
    "phoneNumberLength": [9],
    "code": "AF"
  },
  {
    "name": "Antigua and Barbuda",
    "dial_code": "+1268",
    "phoneNumberLength": [10],
    "code": "AG"
  },
  {
    "name": "Anguilla",
    "dial_code": "+1264",
    "phoneNumberLength": [10],
    "code": "AI"
  },
  {
    "name": "Albania",
    "dial_code": "+355",
    "phoneNumberLength": [9],
    "code": "AL"
  },
  {
    "name": "Armenia",
    "dial_code": "+374",
    "phoneNumberLength": [6],
    "code": "AM"
  },
  {
    "name": "Angola",
    "dial_code": "+244",
    "phoneNumberLength": [9],
    "code": "AO"
  },
  {
    "name": "Antarctica",
    "dial_code": "+672",
    "phoneNumberLength": [6],
    "code": "AQ"
  },
  {
    "name": "Argentina",
    "dial_code": "+54",
    "phoneNumberLength": [6, 7, 8],
    "code": "AR"
  },
  {
    "name": "American Samoa",
    "dial_code": "+1684",
    "phoneNumberLength": [10],
    "code": "AS"
  },
  {
    "name": "Austria",
    "dial_code": "+43",
    "phoneNumberLength": [10, 11],
    "code": "AT"
  },
  {
    "name": "Australia",
    "dial_code": "+61",
    "phoneNumberLength": [9],
    "code": "AU"
  },
  {
    "name": "Aruba",
    "dial_code": "+297",
    "phoneNumberLength": [7],
    "code": "AW"
  },
  {
    "name": "Aland Islands",
    "dial_code": "+358",
    "phoneNumberLength": [7, 8, 9, 10],
    "code": "AX"
  },
  {
    "name": "Azerbaijan",
    "dial_code": "+994",
    "phoneNumberLength": [9],
    "code": "AZ"
  },
  {
    "name": "Bosnia and Herzegovina",
    "dial_code": "+387",
    "phoneNumberLength": [8],
    "code": "BA"
  },
  {
    "name": "Barbados",
    "dial_code": "+1246",
    "phoneNumberLength": [10],
    "code": "BB"
  },
  {
    "name": "Bangladesh",
    "dial_code": "+880",
    "phoneNumberLength": [10],
    "code": "BD"
  },
  {
    "name": "Belgium",
    "dial_code": "+32",
    "phoneNumberLength": [9],
    "code": "BE"
  },
  {
    "name": "Burkina Faso",
    "dial_code": "+226",
    "phoneNumberLength": [8],
    "code": "BF"
  },
  {
    "name": "Bulgaria",
    "dial_code": "+359",
    "phoneNumberLength": [9],
    "code": "BG"
  },
  {
    "name": "Bahrain",
    "dial_code": "+973",
    "phoneNumberLength": [8],
    "code": "BH"
  },
  {
    "name": "Burundi",
    "dial_code": "+257",
    "phoneNumberLength": [8],
    "code": "BI"
  },
  {
    "name": "Benin",
    "dial_code": "+229",
    "phoneNumberLength": [8],
    "code": "BJ"
  },
  {
    "name": "Saint Barthelemy",
    "dial_code": "+590",
    "phoneNumberLength": [9],
    "code": "BL"
  },
  {
    "name": "Bermuda",
    "dial_code": "+1441",
    "phoneNumberLength": [10],
    "code": "BM"
  },
  {
    "name": "Brunei",
    "dial_code": "+673",
    "phoneNumberLength": [7],
    "code": "BN"
  },
  {
    "name": "Bolivia",
    "dial_code": "+591",
    "phoneNumberLength": [9],
    "code": "BO"
  },
  {
    "name": "Brazil",
    "dial_code": "+55",
    "phoneNumberLength": [11],
    "code": "BR"
  },
  {
    "name": "Bahamas",
    "dial_code": "+1242",
    "phoneNumberLength": [10],
    "code": "BS"
  },
  {
    "name": "Bhutan",
    "dial_code": "+975",
    "phoneNumberLength": [7],
    "code": "BT"
  },
  {
    "name": "Bouvet Island",
    "dial_code": "+47",
    "phoneNumberLength": [10],
    "code": "BV"
  },
  {
    "name": "Botswana",
    "dial_code": "+267",
    "phoneNumberLength": [7],
    "code": "BW"
  },
  {
    "name": "Belarus",
    "dial_code": "+375",
    "phoneNumberLength": [9],
    "code": "BY"
  },
  {
    "name": "Belize",
    "dial_code": "+501",
    "phoneNumberLength": [7],
    "code": "BZ"
  },
  {
    "name": "Canada",
    "dial_code": "+1",
    "phoneNumberLength": [10],
    "code": "CA"
  },
  {
    "name": "Cocos Islands",
    "dial_code": "+61",
    "phoneNumberLength": [10],
    "code": "CC"
  },
  {
    "name": "Congo (DRC)",
    "dial_code": "+243",
    "phoneNumberLength": [9],
    "code": "CD"
  },
  {
    "name": "Central African Republic",
    "dial_code": "+236",
    "phoneNumberLength": [8],
    "code": "CF"
  },
  {
    "name": "Republic of Congo",
    "dial_code": "+242",
    "phoneNumberLength": [9],
    "code": "CG"
  },
  {
    "name": "Switzerland",
    "dial_code": "+41",
    "phoneNumberLength": [9],
    "code": "CH"
  },
  {
    "name": "Ivory Coast",
    "dial_code": "+225",
    "phoneNumberLength": [8],
    "code": "CI"
  },
  {
    "name": "Cook Islands",
    "dial_code": "+682",
    "phoneNumberLength": [5],
    "code": "CK"
  },
  {
    "name": "Chile",
    "dial_code": "+56",
    "phoneNumberLength": [9],
    "code": "CL"
  },
  {
    "name": "Cameroon",
    "dial_code": "+237",
    "phoneNumberLength": [9],
    "code": "CM"
  },
  {
    "name": "China",
    "dial_code": "+86",
    "phoneNumberLength": [11],
    "code": "CN"
  },
  {
    "name": "Colombia",
    "dial_code": "+57",
    "phoneNumberLength": [10],
    "code": "CO"
  },
  {
    "name": "Costa Rica",
    "dial_code": "+506",
    "phoneNumberLength": [8],
    "code": "CR"
  },
  {
    "name": "Cuba",
    "dial_code": "+53",
    "phoneNumberLength": [8],
    "code": "CU"
  },
  {
    "name": "Cape Verde",
    "dial_code": "+238",
    "phoneNumberLength": [7],
    "code": "CV"
  },
  {
    "name": "Curacao",
    "dial_code": "+599",
    "phoneNumberLength": [7],
    "code": "CW"
  },
  {
    "name": "Christmas Island",
    "dial_code": "+61",
    "phoneNumberLength": [10],
    "code": "CX"
  },
  {
    "name": "Cyprus",
    "dial_code": "+357",
    "phoneNumberLength": [8],
    "code": "CY"
  },
  {
    "name": "Czech Republic",
    "dial_code": "+420",
    "phoneNumberLength": [9],
    "code": "CZ"
  },
  {
    "name": "Germany",
    "dial_code": "+49",
    "phoneNumberLength": [10, 11],
    "code": "DE"
  },
  {
    "name": "Djibouti",
    "dial_code": "+253",
    "phoneNumberLength": [8],
    "code": "DJ"
  },
  {
    "name": "Denmark",
    "dial_code": "+45",
    "phoneNumberLength": [8],
    "code": "DK"
  },
  {
    "name": "Dominica",
    "dial_code": "+1767",
    "phoneNumberLength": [10],
    "code": "DM"
  },
  {
    "name": "Dominican Republic",
    "dial_code": "+1809",
    "phoneNumberLength": [10],
    "code": "DO"
  },
  {
    "name": "Algeria",
    "dial_code": "+213",
    "phoneNumberLength": [9],
    "code": "DZ"
  },
  {
    "name": "Ecuador",
    "dial_code": "+593",
    "phoneNumberLength": [9],
    "code": "EC"
  },
  {
    "name": "Estonia",
    "dial_code": "+372",
    "phoneNumberLength": [7, 8],
    "code": "EE"
  },
  {
    "name": "Egypt",
    "dial_code": "+20",
    "phoneNumberLength": [10],
    "code": "EG"
  },
  {
    "name": "Western Sahara",
    "dial_code": "+212",
    "phoneNumberLength": [8],
    "code": "EH"
  },
  {
    "name": "Eritrea",
    "dial_code": "+291",
    "phoneNumberLength": [7],
    "code": "ER"
  },
  {
    "name": "Spain",
    "dial_code": "+34",
    "phoneNumberLength": [9],
    "code": "ES"
  },
  {
    "name": "Ethiopia",
    "dial_code": "+251",
    "phoneNumberLength": [9],
    "code": "ET"
  },
  {
    "name": "Finland",
    "dial_code": "+358",
    "phoneNumberLength": [9],
    "code": "FI"
  },
  {
    "name": "Fiji",
    "dial_code": "+679",
    "phoneNumberLength": [7],
    "code": "FJ"
  },
  {
    "name": "Falkland Islands",
    "dial_code": "+500",
    "phoneNumberLength": [5, 6],
    "code": "FK"
  },
  {
    "name": "Micronesia",
    "dial_code": "+691",
    "phoneNumberLength": [7],
    "code": "FM"
  },
  {
    "name": "Faroe Islands",
    "dial_code": "+298",
    "phoneNumberLength": [6],
    "code": "FO"
  },
  {
    "name": "France",
    "dial_code": "+33",
    "phoneNumberLength": [9],
    "code": "FR"
  },
  {
    "name": "Gabon",
    "dial_code": "+241",
    "phoneNumberLength": [9],
    "code": "GA"
  },



  {
    "name": "United Kingdom",
    "dial_code": "+44",
    "phoneNumberLength": [10],
    "code": "GB"
  },
  {
    "name": "Grenada",
    "dial_code": "+1473",
    "phoneNumberLength": [10],
    "code": "GD"
  },
  {
    "name": "Georgia",
    "dial_code": "+995",
    "phoneNumberLength": [9],
    "code": "GE"
  },
  {
    "name": "French Guiana",
    "dial_code": "+594",
    "phoneNumberLength": [9],
    "code": "GF"
  },
  {
    "name": "Guernsey",
    "dial_code": "+44",
    "phoneNumberLength": [10],
    "code": "GG"
  },
  {
    "name": "Ghana",
    "dial_code": "+233",
    "phoneNumberLength": [9],
    "code": "GH"
  },
  {
    "name": "Gibraltar",
    "dial_code": "+350",
    "phoneNumberLength": [8],
    "code": "GI"
  },
  {
    "name": "Greenland",
    "dial_code": "+299",
    "phoneNumberLength": [6],
    "code": "GL"
  },
  {
    "name": "Gambia",
    "dial_code": "+220",
    "phoneNumberLength": [7],
    "code": "GM"
  },
  {
    "name": "Guinea",
    "dial_code": "+224",
    "phoneNumberLength": [8],
    "code": "GN"
  },
  {
    "name": "Guadeloupe",
    "dial_code": "+590",
    "phoneNumberLength": [9],
    "code": "GP"
  },
  {
    "name": "Equatorial Guinea",
    "dial_code": "+240",
    "phoneNumberLength": [8],
    "code": "GQ"
  },
  {
    "name": "Greece",
    "dial_code": "+30",
    "phoneNumberLength": [10],
    "code": "GR"
  },
  {
    "name": "South Georgia and the South Sandwich Islands",
    "dial_code": "+500",
    "phoneNumberLength": [5, 6],
    "code": "GS"
  },
  {
    "name": "Guatemala",
    "dial_code": "+502",
    "phoneNumberLength": [8],
    "code": "GT"
  },
  {
    "name": "Guam",
    "dial_code": "+1671",
    "phoneNumberLength": [10],
    "code": "GU"
  },
  {
    "name": "Guinea-Bissau",
    "dial_code": "+245",
    "phoneNumberLength": [7],
    "code": "GW"
  },
  {
    "name": "Guyana",
    "dial_code": "+592",
    "phoneNumberLength": [7],
    "code": "GY"
  },
  {
    "name": "Hong Kong",
    "dial_code": "+852",
    "phoneNumberLength": [8],
    "code": "HK"
  },
  {
    "name": "Heard Island and McDonald Islands",
    "dial_code": "+672",
    "phoneNumberLength": [6],
    "code": "HM"
  },
  {
    "name": "Honduras",
    "dial_code": "+504",
    "phoneNumberLength": [8],
    "code": "HN"
  },
  {
    "name": "Croatia",
    "dial_code": "+385",
    "phoneNumberLength": [8],
    "code": "HR"
  },
  {
    "name": "Haiti",
    "dial_code": "+509",
    "phoneNumberLength": [8],
    "code": "HT"
  },
  {
    "name": "Hungary",
    "dial_code": "+36",
    "phoneNumberLength": [9],
    "code": "HU"
  },
  {
    "name": "Indonesia",
    "dial_code": "+62",
    "phoneNumberLength": [9],
    "code": "ID"
  },
  {
    "name": "Ireland",
    "dial_code": "+353",
    "phoneNumberLength": [9, 10],
    "code": "IE"
  },
  {
    "name": "Israel",
    "dial_code": "+972",
    "phoneNumberLength": [9],
    "code": "IL"
  },
  {
    "name": "Isle of Man",
    "dial_code": "+44",
    "phoneNumberLength": [10],
    "code": "IM"
  },
  {
    "name": "India",
    "dial_code": "+91",
    "pinCodeLength": 6,
    "phoneNumberLength": [10],
    "code": "IN"
  },
  {
    "name": "British Indian Ocean Territory",
    "dial_code": "+246",
    "phoneNumberLength": [7],
    "code": "IO"
  },
  {
    "name": "Iraq",
    "dial_code": "+964",
    "phoneNumberLength": [10],
    "code": "IQ"
  },
  {
    "name": "Iran",
    "dial_code": "+98",
    "phoneNumberLength": [10],
    "code": "IR"
  },
  {
    "name": "Iceland",
    "dial_code": "+354",
    "phoneNumberLength": [7],
    "code": "IS"
  },
  {
    "name": "Italy",
    "dial_code": "+39",
    "phoneNumberLength": [10],
    "code": "IT"
  },
  {
    "name": "Jersey",
    "dial_code": "+44",
    "phoneNumberLength": [10],
    "code": "JE"
  },
  {
    "name": "Jamaica",
    "dial_code": "+1876",
    "phoneNumberLength": [10],
    "code": "JM"
  },
  {
    "name": "Jordan",
    "dial_code": "+962",
    "phoneNumberLength": [10],
    "code": "JO"
  },
  {
    "name": "Japan",
    "dial_code": "+81",
    "phoneNumberLength": [10],
    "code": "JP"
  },
  {
    "name": "Kenya",
    "dial_code": "+254",
    "phoneNumberLength": [10],
    "code": "KE"
  },
  {
    "name": "Kyrgyzstan",
    "dial_code": "+996",
    "phoneNumberLength": [9],
    "code": "KG"
  },
  {
    "name": "Cambodia",
    "dial_code": "+855",
    "phoneNumberLength": [9],
    "code": "KH"
  },
  {
    "name": "Kiribati",
    "dial_code": "+686",
    "phoneNumberLength": [7],
    "code": "KI"
  },
  {
    "name": "Comoros",
    "dial_code": "+269",
    "phoneNumberLength": [7],
    "code": "KM"
  },
  {
    "name": "Saint Kitts and Nevis",
    "dial_code": "+1869",
    "phoneNumberLength": [10],
    "code": "KN"
  },
  {
    "name": "North Korea",
    "dial_code": "+850",
    "phoneNumberLength": [10],
    "code": "KP"
  },
  {
    "name": "South Korea",
    "dial_code": "+82",
    "phoneNumberLength": [10],
    "code": "KR"
  },
  {
    "name": "Kuwait",
    "dial_code": "+965",
    "phoneNumberLength": [8],
    "code": "KW"
  },
  {
    "name": "Cayman Islands",
    "dial_code": "+1345",
    "phoneNumberLength": [10],
    "code": "KY"
  },
  {
    "name": "Kazakhstan",
    "dial_code": "+7",
    "phoneNumberLength": [10, 11],
    "code": "KZ"
  },
  {
    "name": "Laos",
    "dial_code": "+856",
    "phoneNumberLength": [8],
    "code": "LA"
  },
  {
    "name": "Lebanon",
    "dial_code": "+961",
    "phoneNumberLength": [8],
    "code": "LB"
  },
  {
    "name": "Saint Lucia",
    "dial_code": "+1758",
    "phoneNumberLength": [10],
    "code": "LC"
  },
  {
    "name": "Liechtenstein",
    "dial_code": "+423",
    "phoneNumberLength": [8],
    "code": "LI"
  },
  {
    "name": "Sri Lanka",
    "dial_code": "+94",
    "phoneNumberLength": [9],
    "code": "LK"
  },
  {
    "name": "Liberia",
    "dial_code": "+231",
    "phoneNumberLength": [8],
    "code": "LR"
  },
  {
    "name": "Lesotho",
    "dial_code": "+266",
    "phoneNumberLength": [8],
    "code": "LS"
  },
  {
    "name": "Lithuania",
    "dial_code": "+370",
    "phoneNumberLength": [8],
    "code": "LT"
  },
  {
    "name": "Luxembourg",
    "dial_code": "+352",
    "phoneNumberLength": [8],
    "code": "LU"
  },
  {
    "name": "Latvia",
    "dial_code": "+371",
    "phoneNumberLength": [8],
    "code": "LV"
  },
  {
    "name": "Libya",
    "dial_code": "+218",
    "phoneNumberLength": [10],
    "code": "LY"
  },
  {
    "name": "Morocco",
    "dial_code": "+212",
    "phoneNumberLength": [9],
    "code": "MA"
  },
  {
    "name": "Monaco",
    "dial_code": "+377",
    "phoneNumberLength": [8],
    "code": "MC"
  },
  {
    "name": "Moldova",
    "dial_code": "+373",
    "phoneNumberLength": [8],
    "code": "MD"
  },
  {
    "name": "Montenegro",
    "dial_code": "+382",
    "phoneNumberLength": [8],
    "code": "ME"
  },
  {
    "name": "Saint Martin",
    "dial_code": "+590",
    "phoneNumberLength": [9],
    "code": "MF"
  },
  {
    "name": "Madagascar",
    "dial_code": "+261",
    "phoneNumberLength": [8],
    "code": "MG"
  },
  {
    "name": "Marshall Islands",
    "dial_code": "+692",
    "phoneNumberLength": [7],
    "code": "MH"
  },
  {
    "name": "North Macedonia",
    "dial_code": "+389",
    "phoneNumberLength": [8],
    "code": "MK"
  },
  {
    "name": "Mali",
    "dial_code": "+223",
    "phoneNumberLength": [8],
    "code": "ML"
  },
  {
    "name": "Myanmar",
    "dial_code": "+95",
    "phoneNumberLength": [7, 8, 9, 10],
    "code": "MM"
  },
  {
    "name": "Mongolia",
    "dial_code": "+976",
    "phoneNumberLength": [8],
    "code": "MN"
  },



  {
    "name": "Macao",
    "dial_code": "+853",
    "phoneNumberLength": [8],
    "code": "MO"
  },
  {
    "name": "Northern Mariana Islands",
    "dial_code": "+1670",
    "phoneNumberLength": [7],
    "code": "MP"
  },
  {
    "name": "Martinique",
    "dial_code": "+596",
    "phoneNumberLength": [9],
    "code": "MQ"
  },
  {
    "name": "Mauritania",
    "dial_code": "+222",
    "phoneNumberLength": [8],
    "code": "MR"
  },
  {
    "name": "Montserrat",
    "dial_code": "+1664",
    "phoneNumberLength": [10],
    "code": "MS"
  },
  {
    "name": "Malta",
    "dial_code": "+356",
    "phoneNumberLength": [8],
    "code": "MT"
  },
  {
    "name": "Mauritius",
    "dial_code": "+230",
    "phoneNumberLength": [10],
    "code": "MU"
  },
  {
    "name": "Maldives",
    "dial_code": "+960",
    "phoneNumberLength": [7],
    "code": "MV"
  },
  {
    "name": "Malawi",
    "dial_code": "+265",
    "phoneNumberLength": [7, 8, 9],
    "code": "MW"
  },
  {
    "name": "Mexico",
    "dial_code": "+52",
    "phoneNumberLength": [10, 11],
    "code": "MX"
  },
  {
    "name": "Malaysia",
    "dial_code": "+60",
    "phoneNumberLength": [9, 10],
    "code": "MY"
  },
  {
    "name": "Mozambique",
    "dial_code": "+258",
    "phoneNumberLength": [9],
    "code": "MZ"
  },
  {
    "name": "Namibia",
    "dial_code": "+264",
    "phoneNumberLength": [9],
    "code": "NA"
  },
  {
    "name": "New Caledonia",
    "dial_code": "+687",
    "phoneNumberLength": [6],
    "code": "NC"
  },
  {
    "name": "Niger",
    "dial_code": "+227",
    "phoneNumberLength": [8],
    "code": "NE"
  },
  {
    "name": "Norfolk Island",
    "dial_code": "+672",
    "phoneNumberLength": [5],
    "code": "NF"
  },
  {
    "name": "Nigeria",
    "dial_code": "+234",
    "phoneNumberLength": [10],
    "code": "NG"
  },
  {
    "name": "Nicaragua",
    "dial_code": "+505",
    "phoneNumberLength": [8],
    "code": "NI"
  },
  {
    "name": "Netherlands",
    "dial_code": "+31",
    "phoneNumberLength": [9],
    "code": "NL"
  },
  {
    "name": "Norway",
    "dial_code": "+47",
    "phoneNumberLength": [8],
    "code": "NO"
  },
  {
    "name": "Nepal",
    "dial_code": "+977",
    "phoneNumberLength": [10],
    "code": "NP"
  },
  {
    "name": "Nauru",
    "dial_code": "+674",
    "phoneNumberLength": [7],
    "code": "NR"
  },
  {
    "name": "Niue",
    "dial_code": "+683",
    "phoneNumberLength": [4],
    "code": "NU"
  },
  {
    "name": "New Zealand",
    "dial_code": "+64",
    "phoneNumberLength": [9, 10],
    "code": "NZ"
  },
  {
    "name": "Oman",
    "dial_code": "+968",
    "phoneNumberLength": [8],
    "code": "OM"
  },
  {
    "name": "Panama",
    "dial_code": "+507",
    "phoneNumberLength": [8],
    "code": "PA"
  },
  {
    "name": "Peru",
    "dial_code": "+51",
    "phoneNumberLength": [9],
    "code": "PE"
  },
  {
    "name": "French Polynesia",
    "dial_code": "+689",
    "phoneNumberLength": [6],
    "code": "PF"
  },
  {
    "name": "Papua New Guinea",
    "dial_code": "+675",
    "phoneNumberLength": [7, 8],
    "code": "PG"
  },
  {
    "name": "Philippines",
    "dial_code": "+63",
    "phoneNumberLength": [10],
    "code": "PH"
  },
  {
    "name": "Pakistan",
    "dial_code": "+92",
    "phoneNumberLength": [10, 11],
    "code": "PK"
  },
  {
    "name": "Poland",
    "dial_code": "+48",
    "phoneNumberLength": [9],
    "code": "PL"
  },
  {
    "name": "Saint Pierre and Miquelon",
    "dial_code": "+508",
    "phoneNumberLength": [6],
    "code": "PM"
  },
  {
    "name": "Pitcairn",
    "dial_code": "+64",
    "phoneNumberLength": [4],
    "code": "PN"
  },
  {
    "name": "Puerto Rico",
    "dial_code": "+1",
    "phoneNumberLength": [10],
    "code": "PR"
  },
  {
    "name": "Palestine",
    "dial_code": "+970",
    "phoneNumberLength": [9],
    "code": "PS"
  },
  {
    "name": "Portugal",
    "dial_code": "+351",
    "phoneNumberLength": [9],
    "code": "PT"
  },
  {
    "name": "Palau",
    "dial_code": "+680",
    "phoneNumberLength": [7],
    "code": "PW"
  },
  {
    "name": "Paraguay",
    "dial_code": "+595",
    "phoneNumberLength": [9, 10],
    "code": "PY"
  },
  {
    "name": "Qatar",
    "dial_code": "+974",
    "phoneNumberLength": [7, 8],
    "code": "QA"
  },
  {
    "name": "Reunion",
    "dial_code": "+262",
    "phoneNumberLength": [9],
    "code": "RE"
  },
  {
    "name": "Romania",
    "dial_code": "+40",
    "phoneNumberLength": [9],
    "code": "RO"
  },
  {
    "name": "Serbia",
    "dial_code": "+381",
    "phoneNumberLength": [9, 10, 11, 12],
    "code": "RS"
  },
  {
    "name": "Russia",
    "dial_code": "+7",
    "phoneNumberLength": [10],
    "code": "RU"
  },
  {
    "name": "Rwanda",
    "dial_code": "+250",
    "phoneNumberLength": [9],
    "code": "RW"
  },
  {
    "name": "Saudi Arabia",
    "dial_code": "+966",
    "phoneNumberLength": [9],
    "code": "SA"
  },
  {
    "name": "Solomon Islands",
    "dial_code": "+677",
    "phoneNumberLength": [5, 6, 7],
    "code": "SB"
  },
  {
    "name": "Seychelles",
    "dial_code": "+248",
    "phoneNumberLength": [7],
    "code": "SC"
  },
  {
    "name": "Sudan",
    "dial_code": "+249",
    "phoneNumberLength": [9],
    "code": "SD"
  },
  {
    "name": "Sweden",
    "dial_code": "+46",
    "phoneNumberLength": [7, 9],
    "code": "SE"
  },
  {
    "name": "Singapore",
    "dial_code": "+65",
    "pinCodeLength": 6,
    "phoneNumberLength": [8],
    "code": "SG"
  },
  {
    "name": "Saint Helena",
    "dial_code": "+290",
    "phoneNumberLength": [4],
    "code": "SH"
  },
  {
    "name": "Slovenia",
    "dial_code": "+386",
    "phoneNumberLength": [8],
    "code": "SI"
  },
  {
    "name": "Svalbard and Jan Mayen",
    "dial_code": "+47",
    "phoneNumberLength": [8],
    "code": "SJ"
  },
  {
    "name": "Slovakia",
    "dial_code": "+421",
    "phoneNumberLength": [9],
    "code": "SK"
  },
  {
    "name": "Sierra Leone",
    "dial_code": "+232",
    "phoneNumberLength": [8],
    "code": "SL"
  },
  {
    "name": "San Marino",
    "dial_code": "+378",
    "phoneNumberLength": [10],
    "code": "SM"
  },
  {
    "name": "Senegal",
    "dial_code": "+221",
    "phoneNumberLength": [9],
    "code": "SN"
  },
  {
    "name": "Somalia",
    "dial_code": "+252",
    "phoneNumberLength": [7, 8, 9],
    "code": "SO"
  },
  {
    "name": "Suriname",
    "dial_code": "+597",
    "phoneNumberLength": [6, 7],
    "code": "SR"
  },
  {
    "name": "South Sudan",
    "dial_code": "+211",
    "phoneNumberLength": [9],
    "code": "SS"
  },
  {
    "name": "São Tomé and Príncipe",
    "dial_code": "+239",
    "phoneNumberLength": [7],
    "code": "ST"
  },
  {
    "name": "El Salvador",
    "dial_code": "+503",
    "phoneNumberLength": [8],
    "code": "SV"
  },
  {
    "name": "Sint Maarten",
    "dial_code": "+1721",
    "phoneNumberLength": [10],
    "code": "SX"
  },
  {
    "name": "Syria",
    "dial_code": "+963",
    "phoneNumberLength": [9],
    "code": "SY"
  },
  {
    "name": "Eswatini",
    "dial_code": "+268",
    "phoneNumberLength": [8],
    "code": "SZ"
  },
  {
    "name": "Turks and Caicos Islands",
    "dial_code": "+1649",
    "phoneNumberLength": [10],
    "code": "TC"
  },
  {
    "name": "Chad",
    "dial_code": "+235",
    "phoneNumberLength": [7],
    "code": "TD"
  },
  {
    "name": "French Southern Territories",
    "dial_code": "+262",
    "phoneNumberLength": [10],
    "code": "TF"
  },
  {
    "name": "Togo",
    "dial_code": "+228",
    "phoneNumberLength": [8],
    "code": "TG"
  },
  {
    "name": "Thailand",
    "dial_code": "+66",
    "phoneNumberLength": [9, 10],
    "code": "TH"
  },
  {
    "name": "Tajikistan",
    "dial_code": "+992",
    "phoneNumberLength": [9],
    "code": "TJ"
  },
  {
    "name": "Tokelau",
    "dial_code": "+690",
    "phoneNumberLength": [5],
    "code": "TK"
  },
  {
    "name": "East Timor",
    "dial_code": "+670",
    "phoneNumberLength": [7, 8],
    "code": "TL"
  },




  {
    "name": "Turkmenistan",
    "dial_code": "+993",
    "phoneNumberLength": [8],
    "code": "TKM",
    "example": "+99300000000"
  },
  {
    "name": "Tunisia",
    "dial_code": "+216",
    "phoneNumberLength": [8],
    "code": "TUN",
    "example": "+21600000000"
  },
  {
    "name": "Tonga",
    "dial_code": "+676",
    "phoneNumberLength": [5, 6, 7],
    "code": "TON",
    "example": "+67600000"
  },
  {
    "name": "Turkey",
    "dial_code": "+90",
    "phoneNumberLength": [10],
    "code": "TUR",
    "example": "+900000000000"
  },
  {
    "name": "Trinidad and Tobago",
    "dial_code": "+1868",
    "phoneNumberLength": [7],
    "code": "TTO",
    "example": "+18680000000"
  },
  {
    "name": "Tuvalu",
    "dial_code": "+688",
    "phoneNumberLength": [5],
    "code": "TUV",
    "example": "+68800000"
  },
  {
    "name": "Taiwan",
    "dial_code": "+886",
    "phoneNumberLength": [9],
    "code": "TWN",
    "example": "+886000000000"
  },
  {
    "name": "Tanzania",
    "dial_code": "+255",
    "phoneNumberLength": [9],
    "code": "TZA",
    "example": "+255000000000"
  },
  {
    "name": "Ukraine",
    "dial_code": "+380",
    "phoneNumberLength": [10],
    "code": "UKR",
    "example": "+380000000000"
  },
  {
    "name": "Uganda",
    "dial_code": "+256",
    "phoneNumberLength": [9, 10],
    "code": "UGA",
    "example": "+256000000000"
  },
  {
    "name": "United States",
    "dial_code": "+1",
    "phoneNumberLength": [10],
    "code": "USA",
    "example": "+10000000000"
  },
  {
    "name": "Uruguay",
    "dial_code": "+598",
    "phoneNumberLength": [8],
    "code": "URY",
    "example": "+59800000000"
  },
  {
    "name": "Uzbekistan",
    "dial_code": "+998",
    "phoneNumberLength": [9],
    "code": "UZB",
    "example": "+998000000000"
  },
  {
    "name": "Vatican City",
    "dial_code": "+379",
    "phoneNumberLength": [10],
    "code": "VAT",
    "example": "+3790000000000"
  },
  {
    "name": "Saint Vincent and the Grenadines",
    "dial_code": "+1784",
    "phoneNumberLength": [7],
    "code": "VCT",
    "example": "+17840000000"
  },
  {
    "name": "Venezuela",
    "dial_code": "+58",
    "phoneNumberLength": [10],
    "code": "VEN",
    "example": "+580000000000"
  },
  {
    "name": "British Virgin Islands",
    "dial_code": "+1284",
    "phoneNumberLength": [7],
    "code": "VGB",
    "example": "+12840000000"
  },
  {
    "name": "US Virgin Islands",
    "dial_code": "+1340",
    "phoneNumberLength": [10],
    "code": "VIR",
    "example": "+13400000000"
  },
  {
    "name": "Vietnam",
    "dial_code": "+84",
    "phoneNumberLength": [9, 10],
    "code": "VNM",
    "example": "+84000000000"
  },
  {
    "name": "Vanuatu",
    "dial_code": "+678",
    "phoneNumberLength": [5, 6, 7],
    "code": "VUT",
    "example": "+67800000"
  },
  {
    "name": "Wallis and Futuna",
    "dial_code": "+681",
    "phoneNumberLength": [6],
    "code": "WLF",
    "example": "+681000000"
  },
  {
    "name": "Samoa",
    "dial_code": "+685",
    "phoneNumberLength": [5, 6, 7],
    "code": "WSM",
    "example": "+68500000"
  },
  {
    "name": "Kosovo",
    "dial_code": "+383",
    "phoneNumberLength": [8],
    "code": "XKX",
    "example": "+38300000000"
  },
  {
    "name": "Yemen",
    "dial_code": "+967",
    "phoneNumberLength": [8],
    "code": "YEM",
    "example": "+96700000000"
  },
  {
    "name": "Mayotte",
    "dial_code": "+262",
    "phoneNumberLength": [10],
    "code": "MYT",
    "example": "+2620000000000"
  },
  {
    "name": "South Africa",
    "dial_code": "+27",
    "phoneNumberLength": [9],
    "code": "ZAF",
    "example": "+27000000000"
  },
  {
    "name": "Zambia",
    "dial_code": "+260",
    "phoneNumberLength": [9],
    "code": "ZMB",
    "example": "+260000000000"
  },
  {
    "name": "Zimbabwe",
    "dial_code": "+263",
    "phoneNumberLength": [8],
    "code": "ZWE",
    "example": "+26300000000"
  }
]
